import { render, staticRenderFns } from "./DRSTThumbnail.vue?vue&type=template&id=e3ad0eb2&"
import script from "./DRSTThumbnail.vue?vue&type=script&lang=ts&"
export * from "./DRSTThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTThumbnail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3ad0eb2')) {
      api.createRecord('e3ad0eb2', component.options)
    } else {
      api.reload('e3ad0eb2', component.options)
    }
    module.hot.accept("./DRSTThumbnail.vue?vue&type=template&id=e3ad0eb2&", function () {
      api.rerender('e3ad0eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTThumbnail.vue"
export default component.exports